<template>
    <div>Da obrišete account pošaljite nam email sa vašim podacima na bookeraj@codebuste.rs</div>
</template>
